import { FunctionComponent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import sprite from '../../assets/icons/sprite.svg';

import classNames from 'classnames';
import classes from './MenuOrganisation.module.scss';

interface MenuItem {
  localiseKey: string;
  iconId: string;
  to: string;
}

export const MenuOrganisation: FunctionComponent = () => {
  const { t } = useTranslation();

  const renderMenuItem = useCallback(
    ({ localiseKey, iconId, to }: MenuItem) => {
      const text = t(`orgLayoutMenu.${localiseKey}`);

      return (
        <li key={text}>
          <NavLink
            to={to}
            className={({ isActive }) =>
              classNames(classes['menu__item'], { [classes['menu__item--active']]: isActive })
            }
            {...(to === '/organisation' && { end: true })}
          >
            {iconId && (
              <svg className={classes['menu__item-icon']}>
                <use href={`${sprite}#${iconId}`} />
              </svg>
            )}

            <span className={classes['menu__item-label']}>{text}</span>
          </NavLink>
        </li>
      );
    },
    [t]
  );

  return (
    <ul className={classes['menu']}>
      {renderMenuItem({
        localiseKey: 'channels',
        iconId: 'channels',
        to: '/organisation',
      })}

      {renderMenuItem({
        localiseKey: 'administration',
        iconId: 'administration',
        to: '/organisation/administration',
      })}

      {renderMenuItem({
        localiseKey: 'users',
        iconId: 'users',
        to: '/organisation/users',
      })}

      {renderMenuItem({
        localiseKey: 'notifications',
        iconId: 'bell',
        to: '/organisation/notifications',
      })}

      {renderMenuItem({
        localiseKey: 'analytics',
        iconId: 'analytics',
        to: '/organisation/analytics',
      })}

      {renderMenuItem({
        localiseKey: 'settings',
        iconId: 'settings',
        to: '/organisation/settings',
      })}
    </ul>
  );
};
